// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useExportTypesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getExportTypes = () => {
    return request("GET", `${API_STAGES_URL}/v1/exporttypes`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getExportTypes,
    },
  ]
}

export default useExportTypesApi
